/**
 * Central registry for z-index values to ensure consistent layering across the application.
 */
export const Z_INDEX = {
  // Base elements
  BASE: 0,
  
  // Navigation and headers
  HEADER: 40,
  
  // Dropdowns and popovers
  DROPDOWN: 45,
  
  // Modals and overlays
  // Using 50 as the base for modals (matching Tailwind's z-50 default)
  MODAL_BACKDROP: 50,
  MODAL_CONTAINER: 51,
  
  // Nested or high-priority modals
  // Since we use portals, children rendered later will naturally stack on top.
  // We only need higher values if we want to force a hierarchy.
  HIGH_PRIORITY_MODAL: 60,
  
  // Notifications and tooltips
  TOOLTIP: 70,
  NOTIFICATION: 100,
  
  // Extreme high priority (e.g. global loading states)
  MAX: 9999,
};
